<section class="resumo" *ngIf="temDados" [style.--cor]="segmento.cor" [style.--fundo]="segmento.fundo">
  <div class="topo">
    <span class="icone"><i [class]="segmento.icone"></i></span>
    <div class="titulo">
      <span class="rotulo">Segmento no CRM</span>
      <strong>{{ segmento.nomeSingular }}</strong>
      <em *ngIf="segmento.mostraAtraso && atraso">{{ atraso }} {{ atraso === 1 ? 'dia' : 'dias' }} além do ritmo de compra</em>
    </div>
  </div>

  <div class="numeros">
    <div *ngFor="let n of numeros"><strong>{{ n.valor }}</strong><span>{{ n.rotulo }}</span></div>
  </div>

  <div class="habitos" *ngIf="contato.crmProdutoFavorito || diasPreferidos">
    <span *ngIf="contato.crmProdutoFavorito"><i class="fe-heart"></i>{{ contato.crmProdutoFavorito }}</span>
    <span *ngIf="diasPreferidos"><i class="fe-calendar"></i>costuma pedir {{ diasPreferidos }}</span>
  </div>

  <p class="acao"><i class="fe-target"></i>{{ segmento.acao }}</p>

  <button type="button" class="btn-mia" (click)="miaAberta = true"><i class="fe-zap"></i>Mensagem com a Mia</button>
</section>

<app-mensagem-mia-crm [aberto]="miaAberta" [contato]="contato" (fechar)="miaAberta = false"></app-mensagem-mia-crm>
